import {
  Button,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
} from '@chakra-ui/react'
import { ChevronDownIcon, DownloadIcon } from '@chakra-ui/icons'
import { packageOptionsForExport } from 'src/components/FullDashboardCell/schoolExportShared'

const SchoolCsvDownloadMenu = ({
  packages,
  onDownload,
  downloading,
  label = 'Download CSV',
  size = 'md',
}) => {
  const packageOptions = packageOptionsForExport(packages)

  return (
    <Menu>
      <MenuButton
        as={Button}
        colorScheme="teal"
        size={size}
        leftIcon={<DownloadIcon />}
        rightIcon={<ChevronDownIcon />}
        isLoading={downloading}
        loadingText="Preparing..."
      >
        {label}
      </MenuButton>
      <MenuList maxH="320px" overflowY="auto" zIndex="popover">
        <MenuItem onClick={() => onDownload({ hasCmsSites: true, label: 'Has CMS sites' })}>
          Has CMS sites
        </MenuItem>
        <MenuDivider />
        <MenuGroup title="School package">
          {packageOptions.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() =>
                onDownload({ package: option.value, label: option.label })
              }
            >
              {option.label}
            </MenuItem>
          ))}
        </MenuGroup>
      </MenuList>
    </Menu>
  )
}

export default SchoolCsvDownloadMenu
